import { PolarArea } from "react-chartjs-2";

function PolarAreaChart(props) {
  return <PolarArea data={props.data} />;
}

export default PolarAreaChart;
